import React from 'react';
import { SectionHeading } from './ui/SectionHeading';
import { FadeIn } from './ui/FadeIn';
export function Problema() {
  const dolores = [{
    icon: '💸',
    text: 'Presupuestos que empiezan bajos y terminan carísimos — y ya no podés echarte atrás.'
  }, {
    icon: '🗣️',
    text: 'Chamuyo técnico imposible de entender. Terminás diciendo que sí a todo.'
  }, {
    icon: '🔩',
    text: 'Repuestos que no sabés si realmente cambiaron o te están revendiendo los viejos.'
  }, {
    icon: '⏰',
    text: 'Plata y tiempo perdidos por depender 100% de lo que te dice el mecánico.'
  }];
  return <section className="bg-mc-dark2 py-[72px] px-5" data-id="element-152">
      <div className="max-w-[1100px] mx-auto" data-id="element-153">
        <FadeIn data-id="element-154">
          <SectionHeading data-id="element-155">
            El taller se aprovecha cuando{' '}
            <span className="text-mc-yellow" data-id="element-156">vos no sabés qué preguntar</span>
          </SectionHeading>
          <p className="text-mc-text text-[1.05rem] leading-[1.7] max-w-[640px] mt-5" data-id="element-157">
            Llegás al taller sin saber qué preguntar ni cómo detectar si te
            están inflando el presupuesto. El problema no es no saber mecánica:
            es ir sin una guía para <strong data-id="element-158">defender tu plata</strong>.
          </p>
        </FadeIn>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-9" data-id="element-159">
          {dolores.map((dolor, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-160">
              <div className="bg-mc-gray border-l-4 border-mc-red rounded-lg p-5 flex gap-3.5 items-start h-full" data-id="element-161">
                <div className="text-[1.6rem] shrink-0 mt-0.5" data-id="element-162">
                  {dolor.icon}
                </div>
                <p className="text-mc-text text-[0.95rem]" data-id="element-163">{dolor.text}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}